import { ApolloQueryResult } from 'apollo-boost'
import { apolloClient } from '../apolloClient'
import { GetStatement_listStatements_installmentsOverdue } from '../types/GetStatement'
import { GET_BANK_SLIP_NOTIFICATION } from './queries/GET_BANK_SLIP_NOTIFICATION'

interface Installment extends GetStatement_listStatements_installmentsOverdue {}

export const getOrFailUrlAndBarcodeBankSlip = async (installment: Installment) => {
  const { receivableBillId: billReceivableId, installmentId } = installment
  const input = { billReceivableId, installmentId: installmentId.toString() }

  const response = await apolloClient.query({
    query: GET_BANK_SLIP_NOTIFICATION,
    variables: { input },
  })

  if (response?.data?.getBankSlipNotification?.urlReport) {
    return implementDataInBankSlip(response, installment)
  } else {
    throw new Error('not found url or barcode to bank slip')
  }
}

export const implementDataInBankSlip = (response: ApolloQueryResult<any>, installment: Installment) => {
  const digitableNumber = response?.data?.getBankSlipNotification?.digitableNumber
  const urlReport = response?.data?.getBankSlipNotification?.urlReport
  installment.digitableNumber = digitableNumber
  installment.urlReport = urlReport

  return installment
}
